import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';

type UseVerifyAccount = [(args: UnverifyAccountInput) => Promise<UnverifyAccountOutput>, boolean, string];

export type UnverifyAccountInput = TrpcInputs['unverifyAccount'];
export type UnverifyAccountOutput = TrpcOutputs['unverifyAccount'];

export const useUnverifyAccount = (): UseVerifyAccount => {
  const { mutateAsync, isLoading, error } = trpc.unverifyAccount.useMutation();

  return [mutateAsync, isLoading, error?.message || ''];
};
